import { DatePeriod } from '@fleet-beat/api';

export interface DatePeriodParams {
  period: DatePeriod;
  from: string; // NOTE: ISO date string split by 'T' (e.g. '2021-09-01T00:00:00.000Z' => '2021-09-01')
  to: string; // NOTE: ISO date string split by 'T' (e.g. '2021-09-01T00:00:00.000Z' => '2021-09-01')
}
